import { IModel } from '../base/annotation';
import { Metamodel } from '../base/model';
import { ManagedIdentityCredentialProperties } from './managed-identity-credential-properties';
import { ModelConstants } from '../model-constants';
import { shellStringResources } from '../../Resources/ShellStringResources';

@Metamodel.model({
    name: ModelConstants.userAssignedManagedIdentityCredentialProperties,
    display: [shellStringResources.ModelName_UserAssignedManagedIdentityCredentialProperties]
})
export class UserAssignedManagedIdentityCredentialProperties extends ManagedIdentityCredentialProperties {
    public static readonly MODEL: IModel;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_UamiResourceID
    })
    public resourceId: string;
}
